export const orgOnboardingConstraints = {
    id: { validName: true, presence: { allowEmpty: false } },
    name: { validName: true, presence: { allowEmpty: false } },
    website: { validURL: true },
    duns: { validDUNS: true, presence: { allowEmpty: true } },
    phone: { validPhone: true, presence: { allowEmpty: true } },
};
